import React, { useContext, useEffect, useState } from "react";
import Header from "../components/header/header";
import SidebarProvider from "../components/sidebar/sidebar";
import mainStyles from '../../styles/main.module.css';
import panelStyles from './orphan_invoices.module.css';
import AssignNecModal from "./AssignNecModal";
import Loading from "../../components/loading/loading";
import axiosInstance from "../../AxiosInstance";
import MyContext from "../../MyContext";
import Pagination from "../../components/ajonjolib/utils/pagination";
import { openInvoiceDetail, openOcDetail } from "../../modals/bus/modalApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileContract, faFileInvoice, faSearch } from "@fortawesome/free-solid-svg-icons";
import { toast, ToastTypes } from "../../components/toasts/toast/toast";
import { formatCurrencyAmount, purchaseOrderInvoiceAmountLeft } from "../../utils/currency";

function billDocLabel(t) {
    if (t === 0) return "BOLETA";
    if (t === 1) return "FACTURA";
    return "RHE";
}

export default function OrphanInvoices() {
    const { isClient } = useContext(MyContext);
    const [userType, setUserType] = useState("cliente");

    const [form, setForm] = useState({});
    const [rows, setRows] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [secondaryQuery, setSecondaryQuery] = useState("");
    const [billCount, setBillCount] = useState(0);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [maxItemsPerPage] = useState(25);

    const [poRows, setPoRows] = useState([]);
    const [poFiltered, setPoFiltered] = useState([]);
    const [poQuery, setPoQuery] = useState("");
    const [poLoaded, setPoLoaded] = useState(false);
    const [poPage, setPoPage] = useState(1);
    const [poPageCount, setPoPageCount] = useState(1);
    const [poCount, setPoCount] = useState(0);
    const [poForm] = useState({});
    const [assignModal, setAssignModal] = useState({
        open: false,
        bill: null,
        po: null,
        poDetail: null,
        loading: false,
        submitting: false,
    });
    const [dragOverPoId, setDragOverPoId] = useState(null);

    useEffect(() => {
        setUserType(isClient ? "proveedor" : "cliente");
    }, [isClient]);

    useEffect(() => {
        queryBills(1);
        queryPos(1);
    }, []);

    const queryBills = (page = 1) => {
        setLoaded(false);
        const params = { page, orphan: 1 };
        Object.entries(form).forEach(([key, value]) => {
            if (key === "page" || key === "orphan") {
                return;
            }
            if (value === undefined || value === null) {
                return;
            }
            if (String(value).trim() === "") {
                return;
            }
            params[key] = value;
        });
        params.page = page;
        params.orphan = 1;
        axiosInstance
            .get("bill/", { params })
            .then((response) => {
            const data = response.data;
            setRows(data.results);
            setFilteredRows(data.results);
            setBillCount(data.count ?? 0);
            const totalPages = Math.max(1, Math.ceil((data.count || 0) / maxItemsPerPage));
            setPageCount(totalPages);
            setLoaded(true);
        });
    };

    const queryPos = (page = 1) => {
        setPoLoaded(false);
        const queryParams = Object.entries({ ...poForm })
            .filter(([, value]) => value !== undefined && value !== null && String(value).trim() !== "")
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join("&");
        const url = `purchase_order/?page=${page}&${queryParams}`;
        axiosInstance.get(url).then((response) => {
            const data = response.data;
            setPoRows(data.results);
            setPoFiltered(data.results);
            setPoCount(data.count ?? 0);
            const totalPages = Math.max(1, Math.ceil((data.count || 0) / maxItemsPerPage));
            setPoPageCount(totalPages);
            setPoLoaded(true);
        });
    };

    useEffect(() => {
        if (secondaryQuery === undefined || secondaryQuery === "") {
            setFilteredRows(rows);
            return;
        }
        const lower = secondaryQuery.toLowerCase();
        setFilteredRows(
            rows.filter((row) => {
                return (
                    String(row?.sn ?? "")
                        .toLowerCase()
                        .includes(lower) ||
                    String(row?.xml_supplier_ruc ?? "")
                        .toLowerCase()
                        .includes(lower) ||
                    String(row?.xml_supplier_name ?? "")
                        .toLowerCase()
                        .includes(lower) ||
                    String(row?.xml_customer_ruc ?? "")
                        .toLowerCase()
                        .includes(lower) ||
                    String(row?.xml_customer_name ?? "")
                        .toLowerCase()
                        .includes(lower) ||
                    String(row?.total ?? "")
                        .toLowerCase()
                        .includes(lower)
                );
            })
        );
    }, [secondaryQuery, rows]);

    useEffect(() => {
        if (poQuery === undefined || poQuery === "") {
            setPoFiltered(poRows);
            return;
        }
        const q = poQuery.toLowerCase();
        setPoFiltered(
            poRows.filter((row) => {
                return (
                    row?.client?.name?.toLowerCase().includes(q) ||
                    row?.provider?.name?.toLowerCase().includes(q) ||
                    String(row?.client?.ruc ?? "").includes(q) ||
                    String(row?.provider?.ruc ?? "").includes(q) ||
                    String(row?.number ?? "").toLowerCase().includes(q) ||
                    String(row?.total ?? "").includes(q)
                );
            })
        );
    }, [poQuery, poRows]);

    const openBillDetail = (row) => {
        axiosInstance
            .get(`sunat/${row.id}/`)
            .then((response) => {
                let bill = { ...row, sunat_status: -1, conformity_status: -1 };
                if (response?.status === 200 && response?.data) {
                    const response_data = response.data;
                    bill = {
                        ...row,
                        sunat_status: response_data.ose_sunat_status,
                        conformity_status: response_data.conformity_status,
                    };
                }
                openInvoiceDetail({ bill });
            })
            .catch(() => {
                openInvoiceDetail({
                    bill: { ...row, sunat_status: -2, conformity_status: -2 },
                });
            });
    };

    const openPoDetail = (row) => {
        openOcDetail({
            oc: {
                ...row,
                amount_left: purchaseOrderInvoiceAmountLeft(row),
            },
            userType,
        });
    };

    const onDragStartBill = (e, row) => {
        e.dataTransfer.setData("text/plain", String(row.id));
        e.dataTransfer.effectAllowed = "move";
    };

    const onDragOverPo = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
    };

    const onDropOnPo = async (e, poRow) => {
        e.preventDefault();
        setDragOverPoId(null);
        const id = e.dataTransfer.getData("text/plain");
        if (!id) {
            return;
        }
        const bill = rows.find((r) => String(r.id) === String(id));
        if (!bill) {
            return;
        }
        setAssignModal({
            open: true,
            bill,
            po: poRow,
            poDetail: null,
            loading: true,
            submitting: false,
        });
        try {
            const res = await axiosInstance.get(`purchase_order/${poRow.id}/`);
            setAssignModal((s) => ({ ...s, poDetail: res.data, loading: false }));
        } catch (err) {
            closeAssignModal();
            toast("No se pudo cargar la orden de compra.", ToastTypes.ERROR);
        }
    };

    const closeAssignModal = () => {
        setAssignModal({
            open: false,
            bill: null,
            po: null,
            poDetail: null,
            loading: false,
            submitting: false,
        });
    };

    const confirmAssignNec = async (orderDetailId) => {
        if (!orderDetailId) {
            toast("Seleccione una NEC.", ToastTypes.WARNING);
            return;
        }
        const bill = assignModal.bill;
        if (!bill) {
            return;
        }
        setAssignModal((s) => ({ ...s, submitting: true }));
        try {
            await axiosInstance.post(`bill/${bill.id}/assign-nec/`, {
                order_detail_id: orderDetailId,
            });
            toast("Factura asociada correctamente a la NEC.", ToastTypes.SUCCESS);
            closeAssignModal();
            queryBills(currentPage);
            queryPos(poPage);
        } catch (err) {
            const d = err.response?.data?.detail;
            toast(typeof d === "string" ? d : "No se pudo asociar la factura.", ToastTypes.ERROR);
            setAssignModal((s) => ({ ...s, submitting: false }));
        }
    };

    return (
        <div className={mainStyles.mainContainer}>
            <Header setSidebarOpen={setSidebarOpen} />
            <SidebarProvider index={2} isOpen={sidebarOpen} />

            <div
                className={mainStyles.container}
                style={!sidebarOpen ? { marginLeft: "80px" } : { marginLeft: "285px" }}
            >
                <div className={panelStyles.conciliacionLayout}>
                    {/* Columna facturas huérfanas */}
                    <section className={panelStyles.panelConciliacion} aria-label="Facturas sin OC">
                        <div className={panelStyles.panelHeader}>
                            <h2 className={panelStyles.panelTitle}>
                                <FontAwesomeIcon icon={faFileInvoice} className={panelStyles.panelIcon} />
                                Facturas sin OC asociada
                            </h2>
                            <p className={panelStyles.panelSubtitle}>
                                {loaded ? `${billCount} documento(s) en total` : "…"} · página {currentPage} de {pageCount}
                            </p>
                            <p className="small text-muted mb-2">
                                Arrastre una factura hacia una orden de compra en la columna derecha y elija la NEC.
                            </p>
                            <div className={panelStyles.searchGroup}>
                                <span className={panelStyles.searchPrefix} aria-hidden>
                                    <FontAwesomeIcon icon={faSearch} />
                                </span>
                                <input
                                    type="search"
                                    className={panelStyles.searchInput}
                                    placeholder="Filtrar en esta página: RUC, monto, serie…"
                                    value={secondaryQuery}
                                    onChange={(e) => setSecondaryQuery(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className={panelStyles.panelBody}>
                            {!loaded ? (
                                <Loading />
                            ) : rows.length === 0 ? (
                                <div className={panelStyles.emptyPanel}>No se encontraron facturas huérfanas con los filtros actuales.</div>
                            ) : filteredRows.length === 0 ? (
                                <div className={panelStyles.emptyPanel}>Ninguna fila coincide con el texto de búsqueda local.</div>
                            ) : (
                                filteredRows.map((row) => (
                                    <article
                                        key={row.id}
                                        className={panelStyles.itemFactura}
                                        draggable
                                        onDragStart={(e) => onDragStartBill(e, row)}
                                    >
                                        <div className={panelStyles.itemHeader}>
                                            <span className={panelStyles.itemNumero}>{row.sn || "—"}</span>
                                            <span className={panelStyles.itemTipo}>{billDocLabel(row.invoice_type)}</span>
                                        </div>
                                        <div className={panelStyles.itemMeta}>
                                            Emisor: {row.xml_supplier_name || "—"} · RUC {row.xml_supplier_ruc || "—"}
                                        </div>
                                        <div className={panelStyles.itemMeta}>
                                            Adquirente: {row.xml_customer_name || "—"} · RUC {row.xml_customer_ruc || "—"}
                                        </div>
                                        <div className={panelStyles.itemMeta}>
                                            Recepción: {row.reception_date || "—"} · Emisión: {row.issue_date || "—"}
                                        </div>
                                        <div className={panelStyles.itemDetalles}>
                                            <span>
                                                {formatCurrencyAmount(row.currency, row.total)}
                                            </span>
                                            <button
                                                type="button"
                                                className={panelStyles.pillAction}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openBillDetail(row);
                                                }}
                                            >
                                                Detalles
                                            </button>
                                        </div>
                                    </article>
                                ))
                            )}
                        </div>
                        {loaded && rows.length > 0 ? (
                            <div className={panelStyles.panelFooter}>
                                <Pagination
                                    currentPage={currentPage}
                                    count={pageCount}
                                    arrows={true}
                                    className={'py-1'}
                                    onInput={(page) => {
                                        setCurrentPage(page);
                                        queryBills(page);
                                    }}
                                />
                            </div>
                        ) : null}
                    </section>

                    {/* Columna OC */}
                    <section className={panelStyles.panelConciliacion} aria-label="Órdenes de compra">
                        <div className={panelStyles.panelHeader}>
                            <h2 className={panelStyles.panelTitle}>
                                <FontAwesomeIcon icon={faFileContract} className={panelStyles.panelIcon} />
                                Órdenes de compra disponibles
                            </h2>
                            <p className={panelStyles.panelSubtitle}>
                                {poLoaded ? `${poCount} orden(es) en total` : "…"} · página {poPage} de {poPageCount}
                            </p>
                            <div className={panelStyles.searchGroup}>
                                <span className={panelStyles.searchPrefix} aria-hidden>
                                    <FontAwesomeIcon icon={faSearch} />
                                </span>
                                <input
                                    type="search"
                                    className={panelStyles.searchInput}
                                    placeholder="Filtrar en esta página: OC, RUC, proveedor/cliente, monto…"
                                    value={poQuery}
                                    onChange={(e) => setPoQuery(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className={panelStyles.panelBody}>
                            {!poLoaded ? (
                                <Loading />
                            ) : poRows.length === 0 ? (
                                <div className={panelStyles.emptyPanel}>No hay órdenes de compra en esta página.</div>
                            ) : poFiltered.length === 0 ? (
                                <div className={panelStyles.emptyPanel}>Ninguna fila coincide con el texto de búsqueda local.</div>
                            ) : (
                                poFiltered.map((row) => {
                                    // Misma convención que buy_orders: "proveedor" = usuario cliente (ve al proveedor de la OC)
                                    const counterpartyName =
                                        userType === "proveedor" ? row.provider?.name : row.client?.name;
                                    const counterpartyRuc =
                                        userType === "proveedor" ? row.provider?.ruc : row.client?.ruc;
                                    return (
                                        <article
                                            key={row.id}
                                            className={`${panelStyles.itemOc} ${dragOverPoId === row.id ? panelStyles.itemOcDropTarget : ""}`}
                                            onDragOver={onDragOverPo}
                                            onDragEnter={() => setDragOverPoId(row.id)}
                                            onDragLeave={(e) => {
                                                if (!e.currentTarget.contains(e.relatedTarget)) {
                                                    setDragOverPoId(null);
                                                }
                                            }}
                                            onDrop={(e) => onDropOnPo(e, row)}
                                        >
                                            <div className={panelStyles.itemHeader}>
                                                <span className={panelStyles.itemNumero}>N° {row.number || "—"}</span>
                                                <span className={panelStyles.itemTipo}>
                                                    {row.type === 0 ? "Suministro" : "Servicio"}
                                                </span>
                                            </div>
                                            <div className={panelStyles.itemMeta}>
                                                {userType === "proveedor" ? "Proveedor" : "Cliente"}: {counterpartyName || "—"}
                                                {counterpartyRuc ? ` · RUC ${counterpartyRuc}` : ""}
                                            </div>
                                            <div className={panelStyles.itemMeta}>Emisión: {row.date || "—"}</div>
                                            <div className={panelStyles.itemDetalles}>
                                                <span>
                                                    {formatCurrencyAmount(row.currency, row.total)}
                                                </span>
                                                <button
                                                    type="button"
                                                    className={panelStyles.pillAction}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        openPoDetail(row);
                                                    }}
                                                >
                                                    Detalles
                                                </button>
                                            </div>
                                        </article>
                                    );
                                })
                            )}
                        </div>
                        {poLoaded && poRows.length > 0 ? (
                            <div className={panelStyles.panelFooter}>
                                <Pagination
                                    currentPage={poPage}
                                    count={poPageCount}
                                    arrows={true}
                                    className={'py-1'}
                                    onInput={(page) => {
                                        setPoPage(page);
                                        queryPos(page);
                                    }}
                                />
                            </div>
                        ) : null}
                    </section>
                </div>

                <AssignNecModal
                    show={assignModal.open}
                    onHide={closeAssignModal}
                    bill={assignModal.bill}
                    poDetail={assignModal.poDetail}
                    loading={assignModal.loading}
                    onConfirm={confirmAssignNec}
                    submitting={assignModal.submitting}
                />
            </div>
        </div>
    );
}
